import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';
import { normalValues } from '../../../../constants/normalValues';
import CustomTextField from '../../../../common/CustomTextField';
import { units } from '../../../../constants/units';

const SemenAnalysis = ({ keyPath }) => {
  const dispatch = useDispatch();
  const semenAnalysis = useSelector((state) =>
    getNestedState(state.andrologyReducer, keyPath),
  );
  const seminalFluidAnalysis = useSelector((state) =>
    getNestedState(
      state.andrologyReducer,
      `${keyPath.split('.')[0]}.seminalFluidAnalysis`,
    ),
  );

  const handleChange = (key, value) => {
    console.log(key, value);
    dispatch(setAndrologyData(`${keyPath}.${key}`, value));

    if (key === 'spermCount') {
      const updatedVolume = seminalFluidAnalysis?.volume || 0;
      const updatedSpermCount =
        key === 'spermCount' ? value : seminalFluidAnalysis?.spermCount || 0;
      dispatch(
        setAndrologyData(
          `${keyPath}.totalCount`,
          updatedVolume * updatedSpermCount,
        ),
      );
    }
    if (key === 'progression') {
      let updatedNonProgressive = '';
      const motilityValue = Number(semenAnalysis?.motility) || 0;
      if (motilityValue) {
        updatedNonProgressive = motilityValue - Number(value);
        console.log(value, 'value');
        updatedNonProgressive = !value ? 0 : updatedNonProgressive;
        dispatch(
          setAndrologyData(`${keyPath}.nonProgression`, updatedNonProgressive),
        );
      }
    }

    if (key === 'motility') {
      const updatedKey = 'immotile';
      const updatedValue = 100 - value;
      dispatch(setAndrologyData(`${keyPath}.${updatedKey}`, updatedValue));
    }
  };

  return (
    <Box flex={1}>
      <Paper className="p-3 mb-3">
        <Typography variant="h6" gutterBottom>
          Analysis of Sperm
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                  Parameter
                </TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                  Value
                </TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                  WHO Normal Values
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Sperm Count</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.spermCount}
                    onChange={(e) => {
                      handleChange('spermCount', e.target.value);
                      const volume = seminalFluidAnalysis.volume;
                      if (volume > 0) {
                        handleChange('totalCount', e.target.value * volume);
                      }
                    }}
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.spermCount}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.spermCount}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total Count</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.totalCount}
                    onChange={(e) => handleChange('totalCount', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.totalCount}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.totalCount}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Motility (%)</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.motility}
                    onChange={(e) => handleChange('motility', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.motility}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.motility}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>a. Progression</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.progression}
                    onChange={(e) =>
                      handleChange('progression', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.progression}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.progression}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>b. Non progressive</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.nonProgression}
                    onChange={(e) =>
                      handleChange('nonProgression', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.nonProgression}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.nonProgression}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>b. Immotile</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.immotile}
                    onChange={(e) => handleChange('immotile', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.immotile}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.immotile}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Viability (% live)</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.viability}
                    onChange={(e) => handleChange('viability', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.viability}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.viability}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Morphology (% normal form)</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.morphologyNormal}
                    onChange={(e) => {
                      handleChange('morphologyNormal', e.target.value);
                      handleChange('morphologyAbnormal', 100 - e.target.value);
                    }}
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.morphologyNormal}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.morphologyNormal}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Morphology (% abnormal form)</TableCell>
                <TableCell>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={semenAnalysis.morphologyAbnormal}
                    onChange={(e) =>
                      handleChange('morphologyAbnormal', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                    suffix={units.spermAnalysis.morphologyAbnormal}
                  />
                </TableCell>
                <TableCell>
                  <CustomTextField
                    disabled
                    value={normalValues.spermAnalysis.morphologyAbnormal}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default SemenAnalysis;
